export const TASK_CENTER = Object.freeze({
  path: '/task-center',
  label: 'Task Center',
});

export const DASHBOARD = Object.freeze({
  path: '/dashboard',
  label: 'Dashboard',
});

export const OPERATING_FEED = Object.freeze({
  path: '/operating-feed',
  label: 'Operating Feed',
});

export const PAYMENT = Object.freeze({
  path: '/payment',
  label: 'Payment',
});

export const HR_GUIDANCE = Object.freeze({
  path: '/guidance',
  label: 'HR Guidance',
});

export const CABINET = '/cabinet/active';

export const BILLING = '/settings#plans';

export const MY_TEAM = '/my-team';

// Note: DefaultLandingRoutes are now determined dynamically by getLandingPageRoute()
// in utils/landingPage.ts based on the h3-flywheel feature flag
export const DefaultLandingRoutes = Object.freeze({
  USER: DASHBOARD, // Fallback - actual route determined by feature flag
  EMPLOYEE: DASHBOARD, // Fallback - actual route determined by feature flag
  LEAD: PAYMENT,
});

export default DefaultLandingRoutes;
